import React from 'react';
import {
  createFrontendPlugin,
  ApiBlueprint,
  PageBlueprint,
  NavItemBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { createRouteRef } from '@backstage/core-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import { projectsRegistryApiRef } from './api/ProjectsRegistryApi';
import { ProjectsRegistryApiClient } from './api/ProjectsRegistryApiClient';
import StorageIcon from '@material-ui/icons/Storage';

const rootRouteRef = createRouteRef({ id: 'projects-registry' });

const registryPage = PageBlueprint.make({
  name: 'projects-registry',
  params: {
    path: '/projects-registry',
    routeRef: rootRouteRef,
    loader: async () =>
      import('./components/RegistryPage').then(m =>
        compatWrapper(React.createElement(m.RegistryPage)),
      ),
  },
});

const registryNavItem = NavItemBlueprint.make({
  name: 'projects-registry',
  params: {
    title: 'Projects Registry',
    icon: StorageIcon,
    routeRef: rootRouteRef,
  },
});

const registryApi = ApiBlueprint.make({
  name: 'projects-registry',
  params: defineParams =>
    defineParams({
      api: projectsRegistryApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ProjectsRegistryApiClient({ discoveryApi, fetchApi }),
    }),
});

const projectsRegistryPlugin = createFrontendPlugin({
  pluginId: 'projects-registry',
  extensions: [registryPage, registryNavItem, registryApi],
  routes: {
    root: rootRouteRef,
  },
});

export default projectsRegistryPlugin;
